import { IFileUpload } from "./IFileUpload";
import { FileUploadGalleryItem } from "./FileUploadGalleryItem";
import { useState } from "react";
export interface IFileUploadGalleryProps {
    
    files : IFileUpload[]
    onDelete : (file:IFileUpload) => void
}



export const FileUploadGallery = (props:IFileUploadGalleryProps) => {


    


    return <>
    
    { ( props.files.length > 0 ) && <>
        
            <div className="container mr-file-upload-gallery">
                
                {
                    props.files.map((file, idx) => <FileUploadGalleryItem key={idx} file={file} onDelete={props.onDelete} /> )
                }

            </div>
    
        </>
    }
        

    </>;

}